import {
  annotationHex,
  annotationInCrop,
  annotationStroke,
  arrowGeometry,
  type Annotation,
  type Box,
} from '@nolens/domain';

const FULL: Box = { x: 0, y: 0, w: 1, h: 1 };

/**
 * Destaques e setas por cima de uma captura (SVG do tamanho do contentor). `aspect` é a
 * proporção da área mostrada, para o traço e a ponta das setas não ficarem deformados.
 */
export function AnnotationLayer({
  annotations,
  crop = FULL,
  aspect,
}: {
  annotations: Annotation[] | undefined;
  crop?: Box;
  aspect: number;
}) {
  if (!annotations?.length) return null;
  const W = 1000;
  const H = W / (aspect || 1);
  const sw = annotationStroke(W, H);
  return (
    <svg
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 h-full w-full overflow-visible"
      viewBox={`0 0 ${W} ${H}`}
      preserveAspectRatio="none"
      data-annotations={annotations.length}
    >
      {annotations.map((raw, i) => {
        const a = annotationInCrop(raw, crop);
        const color = annotationHex(a);
        if (a.kind === 'box') {
          const r = { x: a.x * W, y: a.y * H, width: a.w * W, height: a.h * H, rx: sw * 1.5 };
          return (
            <g key={i}>
              <rect {...r} fill="none" stroke="#fff" strokeOpacity={0.75} strokeWidth={sw + 3} />
              <rect {...r} fill={color} fillOpacity={0.08} stroke={color} strokeWidth={sw} />
            </g>
          );
        }
        const from = { x: a.from.x * W, y: a.from.y * H };
        const to = { x: a.to.x * W, y: a.to.y * H };
        const g = arrowGeometry(from, to, sw);
        const pts = g.head.map((p) => `${p.x},${p.y}`).join(' ');
        return (
          <g key={i} strokeLinecap="round" strokeLinejoin="round">
            <line
              x1={from.x}
              y1={from.y}
              x2={g.shaftEnd.x}
              y2={g.shaftEnd.y}
              stroke="#fff"
              strokeOpacity={0.75}
              strokeWidth={sw + 3}
            />
            <polygon
              points={pts}
              fill="#fff"
              fillOpacity={0.75}
              stroke="#fff"
              strokeOpacity={0.75}
              strokeWidth={3}
            />
            <line
              x1={from.x}
              y1={from.y}
              x2={g.shaftEnd.x}
              y2={g.shaftEnd.y}
              stroke={color}
              strokeWidth={sw}
            />
            <polygon points={pts} fill={color} stroke={color} strokeWidth={1} />
          </g>
        );
      })}
    </svg>
  );
}
